export default __webpack_public_path__ + "static/media/men_ico.dbdab6ce.svg";